// !!! DON'T FORGET TO UPDATE index.ts IF YOU ADD A NEW MODULE
export enum ModuleID {
  CLIENT = 'client',
  LOCALE = 'locale',
  TIMELINE = 'timeline',
  IMAGES = 'images',
  WEBCAM = 'webcam',
  VIDEOS = 'videos',
  VIEWPORT = 'viewport',
  PREVIEW = 'preview',
  THEME = 'theme',
  THEME_EDITOR = 'theme_editor',
  MODAL = 'modal',
  DEV_LOG = 'dev_log',
  SURVEY_LOG = 'survey_log',
  MOUSE_LOG = 'mouse_log',
  HOOKS = 'hooks',
  SUPERVISOR = 'supervisor',
  VOID = 'void',
  TOOLBAR = 'toolbar'
}

export interface IModule {
  get id(): ModuleID
  config(props: unknown): IModule
  load(): Promise<IModule>
  get loaded(): boolean
}
